import {Comment} from '../../../../../integration/representation/contract';
import React from 'react';
import SingleComment from './SingleComment';

interface CommentsModalFeatureCommentsProps {
    featureName: string;
    comments: Comment[];
    showTitle: boolean;
}

export default class CommentsModalFeatureComments extends React.Component<CommentsModalFeatureCommentsProps, {}> {
    render() {
        const {featureName, comments} = this.props;
        return (
            <section>
                {this.props.showTitle && <h3>{featureName}</h3>}
                {comments.map(comment => (
                    <SingleComment key={comment.id} comment={comment} commentResource={'FEATURE_TYPE_COMMENT'}/>
                ))}
                <hr/>
            </section>
        );
    }
}
